import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sidebar } from "../../components/Sidebar";
import { PageHeader } from "../../components/UI";
import GreenMilesHotelForm from "../../components/GreenMiles/CreateHotel/GreenMilesHotelForm";

const CreateGreenMilesHotelPage = () => {
  const navigate = useNavigate();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [createdHotelData, setCreatedHotelData] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");

  const handleSuccess = (hotelData, message) => {
    setCreatedHotelData(hotelData);
    setSuccessMessage(message);
    setShowSuccessModal(true);
  };

  const handleCancel = () => {
    navigate("/greenmiles");
  };

  const handleGoToHotel = () => {
    if (createdHotelData?.hotelId) {
      navigate(`/hotels/${createdHotelData.hotelId}/greenmiles`);
    }
  };

  const handleGoToGreenMilesHome = () => {
    navigate("/greenmiles");
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />

      <div className="flex-1 flex flex-col overflow-hidden">
        <PageHeader 
          title="Créer un hôtel GreenMiles" 
          subtitle="Créez un nouvel hôtel avec génération automatique des chambres" 
          breadcrumbs={[{ label: "GreenMiles", href: "/greenmiles" }, { label: "Créer un hôtel" }]}
          onGoBack={() => navigate("/greenmiles")}
        />

        <div className="flex-1 overflow-y-auto">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
              <div className="flex items-start">
                <span className="text-[#365644] text-xl mr-3">🏨</span>
                <div>
                  <h3 className="font-medium text-[#365644] mb-1">Création d'hôtel GreenMiles</h3>
                  <p className="text-sm text-green-800">Cette fonctionnalité créera automatiquement :</p>
                  <ul className="text-sm text-green-800 mt-2 space-y-1">
                    <li>• L'hôtel dans la base de données</li>
                    <li>• Toutes les chambres avec numérotation automatique</li>
                    <li>• L'attribution automatique des étages (10 chambres par étage)</li>
                    <li>• Les chambres prêtes pour l'association de codes QR ultérieure</li>
                  </ul>
                </div>
              </div>
            </div>

            <GreenMilesHotelForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </div>
        </div>

        {/* Modal de succès */}
        {showSuccessModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
              <div className="text-center">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
                  <span className="text-green-600 text-2xl">✅</span>
                </div>

                <h3 className="text-lg font-medium text-gray-900 mb-2">Hôtel créé avec succès !</h3>

                <p className="text-sm text-gray-600 mb-4">{successMessage}</p>

                {createdHotelData && (
                  <div className="bg-gray-50 rounded-md p-3 mb-4 text-left">
                    <div className="text-sm space-y-1">
                      <div>
                        <strong>Hôtel:</strong> {createdHotelData.hotelName}
                      </div>
                      <div>
                        <strong>ID:</strong> {createdHotelData.hotelId}
                      </div>
                      <div>
                        <strong>Chambres créées:</strong> {createdHotelData.roomsCreated}
                      </div>
                      {createdHotelData.sampleRooms && createdHotelData.sampleRooms.length > 0 && (
                        <div className="mt-2">
                          <strong>Exemples de chambres:</strong>
                          <ul className="text-xs mt-1 space-y-1">
                            {createdHotelData.sampleRooms.map((room, index) => (
                              <li key={index} className="flex justify-between">
                                <span>Chambre {room.roomNumber}</span>
                                <span className="text-gray-500">Étage {room.floor}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <div className="flex flex-col sm:flex-row gap-3">
                  <button onClick={handleGoToHotel} className="flex-1 px-4 py-2 bg-[#365644] text-white text-sm font-medium rounded-md hover:bg-[#2d4c3c] focus:outline-none focus:ring-2 focus:ring-[#365644]">
                    Voir l'hôtel
                  </button>
                  <button onClick={handleGoToGreenMilesHome} className="flex-1 px-4 py-2 bg-gray-600 text-white text-sm font-medium rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500">
                    Retour à GreenMiles
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateGreenMilesHotelPage;
